import { Box, Typography, Stack } from '@mui/material';
import { format, parse, parseISO } from 'date-fns';
import React from 'react';

import { theme } from '@app/theme';
import { Product } from '@app/types/catalog';

interface PublishInfoProps {
  product: Product;
}

export function PublishInfo({ product }: PublishInfoProps) {
  if (typeof product.organization === 'string') {
    return null;
  }
  const rows = [
    {
      label: '情報提供日',
      value: format(parseISO(product.updatedAt), 'yyyy年MM月dd日'),
    },
    {
      label: '次回更新日',
      value: '情報提供より8日以内に更新',
    },
    {
      label: '取引有効期限',
      value: product.customFields.transactionExpirationDate
        ? format(
            parse(
              product.customFields.transactionExpirationDate,
              'yyyy/MM/dd',
              new Date()
            ),
            'yyyy年MM月dd日'
          )
        : '-',
    },
  ];
  return (
    <Box>
      <Typography
        width="100%"
        bgcolor={theme.palette.blueAccent.main}
        color="white"
        px={2}
        height={36}
        fontWeight={600}
        borderRadius={15}
        display="flex"
        alignItems="center"
        variant="h6"
      >
        情報提供日・更新日
      </Typography>
      <Stack spacing={2.5} maxWidth={1040} mx="auto" width="100%" mt={4}>
        {rows.map(({ label, value }, index) => (
          <Stack
            borderBottom={1}
            borderColor="#E0E0E0"
            key={index}
            direction={{ sm: 'row', xs: 'column' }}
            spacing={1}
            pb={2.5}
          >
            <Typography
              sx={{
                color: '#718CA0',
                fontWeight: 700,
                minWidth: 200,
                whiteSpace: 'nowrap',
              }}
            >
              {label}
            </Typography>
            <Typography
              sx={{
                whiteSpace: 'pre-wrap',
              }}
            >
              {value}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}
